<template>
   <div class="bg-white radius">
       <div class="flex align-center justify-between margin-top-sm margin-lr-sm">
           <p class="text-black text-bold text-df">编辑</p>
           <el-button class="btn small self-end " type="primary" @click="$router.go(-1)">返回</el-button>
       </div>
       <div class="edit-all flex align-center">
           <div class="edit-contents flex-sub">
               <div class="flex flex-direction">
                   <p class="mode-text">版块名称：</p>
                   <el-input class="margin-top-xs" v-model="title" :disabled="readonly" placeholder="请输入版块名称" type="text"></el-input>
               </div>
               <div class="mode-content flex align-center justify-between margin-top-xs">
                   <p class="mode-text">版块内容：</p>
                   <div class="import-btn"  @click="kaifa">应用现有模板</div>
               </div>
               <div class="mode-edit margin-top-xs">
                   <VueUditorWrap  v-model="content" :config="myConfig"></VueUditorWrap>
               </div>
               <div class="edit-btn-box">
                   <el-button class="edit-btn" @click="submit">提交</el-button>
                   <el-button class="edit-btn active" @click="closeText">清空</el-button>
               </div>
           </div>
           <div class="exhibition">
               <div class="phone-box">
                   <div class="phone-content">
                       <img alt="" class="phone-tit" src="../../../../assets/img/phone-top.png">
                       <div ref="exhibition" class="wrapper exhibition-text">
                           <ul ref="exhibitionbox" class="content exhibition-text-box">
                               <li class="card-top">
                                   <img alt="" class="card-logo" src="../../../../assets/img/zch.png">
                                   <div class="car-info">
                                       <img alt="" class="card-logo2" src="../../../../assets/img/zch.png">
                                       <h3>北京知诚社会组织众扶发展促进会</h3>
                                       <h2>您的名字</h2>
                                       <p>您的职位</p>
                                       <div class="card-other">
                                           <div>
                                               <span class="left">手机：</span>
                                               <span class="cente">18830113300  </span>
                                               <b>拨打</b>
                                           </div>
                                           <div>
                                               <span class="left">微信：</span>
                                               <span class="cente">yxb  </span>
                                               <b>复制</b>
                                           </div>
                                           <div>
                                               <span class="left">座机：</span>
                                               <span class="cente">010-62744360 </span>
                                               <b>拨打</b>
                                           </div>
                                           <div>
                                               <span class="left">邮箱：</span>
                                               <span class="cente">yxb@emof.net </span>
                                               <b>复制</b>
                                           </div>
                                           <div>
                                               <span class="left">地址：</span>
                                               <span class="cente">北京市海淀区北京大学</span>
                                               <b>导航</b>
                                           </div>
                                       </div>
                                   </div>
                               </li>
                               <li v-for="item in allList" :key="item.type_id" class="card-center">
                                   <div v-if="item.appoint_type_id === id || item.type_id=== id">
                                       <div ref="editRef" class="card-center-title">
                                           <img alt="" src="../../../../assets/img/jgjsIcon.png">
                                           {{ title }}
                                       </div>
                                       <div class="card-center-info" v-html="content">
                                       </div>
                                   </div>
                                   <div v-else>
                                       <div class="card-center-title">
                                           <img alt="" src="../../../../assets/img/jgjsIcon.png">
                                           {{ item.title }}
                                       </div>
                                       <div class="card-center-info" v-html="item.content">
                                       </div>
                                   </div>
                               </li>
                           </ul>
                       </div>

                   </div>
                   <div class="set-btn">
                       <a href="javascript:void 0" @click="scrollSize(0)">顶部</a>
                       <a href="javascript:void 0" @click="scrollSize(-300)">上翻</a>
                       <a href="javascript:void 0" @click="scrollSize(300)">下翻</a>
                       <a href="javascript:void 0" @click="scrollSize(-1)">底部</a>
                   </div>
               </div>
           </div>
       </div>
   </div>
</template>

<script>
import VueUditorWrap from 'vue-ueditor-wrap'
import BetterScroll from 'better-scroll'
import {TOAST, toast} from "@/utils/utils";
import {
    contentShowAppoint,
    contentShow,
    getOrgTypeContentAll,
    createTypeContentAppoint,
    createTypeContent
} from "@/api";
import {basic_classify} from "@/utils/const";
import {bdEditConfig} from "@/config";

export default {
    name: "edit",
    components:{VueUditorWrap},
    data() {
        return {
            myConfig: bdEditConfig(),
            id:0,
            title:'',
            content:'',
            readonly:true,
            scrollNum: 0,
            allList: [],
            isScrollState: true,
            bs:'',
        }
    },
    created() {
        this.id = Number(this.$route.params.id || 0)
        this.$emit('setIndex', [1, 1], '内容管理')
        this.init()
        this.getOrgTypeContentAll()
    },
    mounted() {

    },
    methods: {
        async init() {
            let _data = this.id > 4 ?  await contentShow(this.id)  : await contentShowAppoint(this.id)
            if (this.id > 4) {
                this.readonly = false
                this.title = _data.data.title
                this.content = _data.data.content
            } else {
                this.title = basic_classify[this.id -1].type_name
                this.content = _data.data.content
                this.readonly = true
            }
        },
        async getOrgTypeContentAll() {
            let _data = await getOrgTypeContentAll()
            this.allList = _data.data
        },
        async submit() {
            if (!this.title) return toast('请输入模块名称', TOAST.error)
            if (!this.content) return toast('请输入模块内容', TOAST.error)
            let _data = this.id > 4 ? await createTypeContent(this.id,this.title,this.content)
                : await createTypeContentAppoint(this.id,this.title,this.content)
            if (_data.status === 200) {
                toast('保存成功')
            } else {
                toast(_data.msg, TOAST.error)
            }
        },
        scrollSize(num) {
            let maxHeight = this.bs.maxScrollY * -1 //最大
            let cur_height = this.bs.y  * -1 //最大
            let scrollNum = 0
            console.log(maxHeight,cur_height)
            if (num === 0) {
                scrollNum = 0
                this.bs.scrollTo(0,0)
            } else if (num === 300) {
                scrollNum = cur_height + 300 > maxHeight ? maxHeight : cur_height + 300
                this.bs.scrollTo(0,scrollNum  * -1)
            } else if (num === -300) {
                scrollNum = cur_height - 300 > 0 ? cur_height - 300 : 0
                this.bs.scrollTo(0,scrollNum  * -1)
            } else {
                scrollNum = maxHeight
                this.bs.scrollTo(0,scrollNum  * -1)
            }

        },
        // 清除数据
        closeText() {
            this.content = ''
            this.close = true
        },
        kaifa() {
            toast('功能正在研发中，请您耐心等待',TOAST.error)
        },
        //  同步富文本内容
        change() {
            setTimeout(() => {
                // if (this.$refs.editRef && this.isScrollState) {
                let num = this.$refs.editRef[0].offsetTop
                this.scrollNum = (num) * -1
                this.bs = new BetterScroll('.wrapper', {
                    scrollY: true,
                    startY:  this.scrollNum
                })
                //   this.isScrollState = false
                // }
            }, 800)

        },
    },
    watch:{
        content(){
            this.change()
        }
    }
}
</script>

<style lang="scss" scoped>
.edit-all {
    .edit-contents {
        padding: 20px;
        border-radius: 10px;
        background-color: #ffffff;

        .mode-text {
            font-size: 16px;
            line-height: 24px;
            font-weight: bold;
        }

        .mode-content {
            .mode-text {
                font-size: 16px;
                line-height: 24px;
            }

            .mode-edit {
                width: 674px;
                min-height: 400px;
                overflow: hidden;
            }

            .import-btn {
                width: 120px;
                height: 35px;
                background-color: #0a2240;
                border-radius: 20px;
                font-size: 12px;
                line-height: 35px;
                text-align: center;
                color: #ffffff;
            }
        }


        .edit-btn-box {
            padding-top: 20px;

            .edit-btn {
                width: 110px;
                height: 40px;
                background-color: #ff9600;
                border-radius: 20px;
                border: solid 1px #ffffff;
                font-size: 16px;
                color: #ffffff;

                &.active {
                    border-radius: 20px;
                    border: solid 1px #0a2240;
                    color: #0a2240;
                    background: transparent;
                }
            }
        }
    }

    .exhibition {
        width: 356px;
        padding: 30px;

        .phone-box {
            width: 303px;
            height: 618px;
            padding: 70px 16px;
            background: url(../../../../assets/img/phone.png) no-repeat;
            position: relative;

            .phone-content {
                height: 100%;
                background: #f0f4f7;
                border: 2px solid #9c9c9c;
                padding-top: 60px;
                overflow: hidden;
                position: relative;

                .phone-tit {
                    position: absolute;
                    top: 0;
                    left: 0;
                    display: block;
                    width: 100%;
                }

                .exhibition-text {
                    height: 100%;
                    overflow-y: scroll;

                    &::-webkit-scrollbar {
                        display: none
                    }

                    .exhibition-text-box {
                        width: 100%;

                        margin-bottom: 20px;

                        .card-top {
                            margin: 10px;
                            /*background: #f5f5f5;*/
                            /*height: 300px;*/
                            padding-top: 30px;
                            border-radius: 5px;
                            box-shadow: 0px 0px 5px 0px #67b8ff;

                            .card-logo {
                                display: block;
                                width: 50%;
                                margin: 0 auto;
                            }

                            .car-info {
                                margin-top: 21px;
                                width: 100%;
                                /*height: 123px;*/
                                padding-top: 50px;
                                background: url(../../../../assets/img/wdBgc.png) no-repeat top center;
                                background-size: 100%;
                                border-radius: 5px;
                                position: relative;

                                .card-logo2 {
                                    position: absolute;
                                    top: 5px;
                                    left: 109px;
                                    width: 30px;
                                    height: 30px;
                                }

                                h3 {
                                    text-align: center;
                                    font-weight: bold;
                                    margin-bottom: 5px;
                                }

                                h2 {
                                    font-size: 16px;
                                    text-align: center;
                                    font-weight: bold;
                                    margin-bottom: 5px;
                                }

                                p {
                                    text-align: center;
                                    color: #666;
                                }

                                .card-other {
                                    margin-top: 15px;
                                    background: #fff;
                                    border-radius: 5px;
                                    padding-bottom: 15px;

                                    div {
                                        display: flex;
                                        align-items: self-start;
                                        margin: 0 10px;
                                        border-bottom: 1px solid #d3d3d3;
                                        line-height: 30px;

                                        .left {
                                            width: 45px;
                                            color: #666;
                                            font-size: 13px;
                                        }

                                        .cente {
                                            width: 140px;
                                            padding-right: 10px;
                                            color: #666;
                                            font-size: 13px;
                                        }

                                        b {
                                            display: block;
                                            width: 40px;
                                            height: 24px;
                                            line-height: 24px;
                                            text-align: center;
                                            margin-top: 3px;
                                            border: 1px solid #67b8ff;
                                            border-radius: 4px;
                                            font-size: 12px;
                                            color: #67b8ff;

                                        }
                                    }
                                }
                            }
                        }

                        .card-center {
                            margin: 10px;
                            background: #fff;
                            /*min-height: 200px;*/
                            border-radius: 5px;
                            box-shadow: 0px 0px 5px 0px #67b8ff;

                            .card-center-title {
                                display: flex;
                                align-items: center;
                                height: 50px;
                                padding: 0 10px;
                                font-size: 16px;
                                font-weight: bold;
                                border-bottom: 1px solid #d3d3d3;

                                img {
                                    width: 20px;
                                    margin-right: 5px;
                                }
                            }

                            .card-center-info {
                                padding: 10px;
                            }
                        }
                    }
                }

            }

            .set-btn {
                display: flex;
                align-items: center;
                justify-content: space-between;
                position: absolute;
                left: 0;
                bottom: 40px;
                padding: 0 20px;
                width: 100%;

                a {
                    width: 20%;
                    color: #fff;
                    background: #67b8ff;
                    text-align: center;
                    border-radius: 5px;
                }
            }
        }
    }
}
</style>